import { LandingPage } from '@pages/landing'

import { getPromoLandingCode } from './promoHost'

interface PromoSubdomainRootProps {
  /** What the root renders off a promo host — the main page. */
  children: React.ReactNode;
}

/*
  The root of a promo subdomain IS its landing:

    school.promo.shop.anvar.kz/  ->  the landing whose code is "school"

  Rendered in place rather than redirected, so the address stays the bare
  domain instead of growing a /landing/school that merely repeats what the host
  already says. The /landing/:code route still works and is unchanged — this is
  a second way in, not a replacement.

  Only the root is affected. Every other path on the host serves the normal
  site, so a visitor can browse the catalog and check out without leaving the
  promo skin (the header follows via usePromoSiteHeader).
*/
export function PromoSubdomainRoot ({ children }: PromoSubdomainRootProps) {
  const code = getPromoLandingCode()

  if (!code) {
    return <>{children}</>
  }

  // The code comes from the host; LandingPage falls back to it when the route
  // carries no :code param.
  return <LandingPage />
}
